export enum ContentType {
  AUDIO_VIDEO = 'audio/video', // DEFAULT
  VIDEO = 'video',
  AUDIO = 'audio',
  IMAGE = 'image',
}
